import dotenv from 'dotenv';

dotenv.config();

export const productionConfig = {
    dcbService: `${process.env.VUE_APP_DCB_SERVICE}`,
    triviaService: `${process.env.VUE_APP_TRIVIA_SERVICE}`,
    triviaBasicAuthToken: `${process.env.VUE_APP_TRIVIA_BASIC_AUTH_TOKEN}`,
    triviaLegacyService: `${process.env.VUE_APP_TRIVIA_LEGACY_SERVICE}`,
    utilsService: `${process.env.VUE_APP_UTILS_SERVICE}`,
    upstreamService: `${process.env.VUE_APP_UPSTREAM_SERVICE}`,
    fantasyService: `${process.env.VUE_APP_FANTASY_SERVICE}`,
    gameEngineService: `${process.env.VUE_APP_GAME_ENGINE_SERVICE}`,
    predictorService: `${process.env.VUE_APP_PREDICTOR_SERVICE}`,
    authHeader: `${process.env.VUE_APP_AUTHORIZATION_HEADERS}`,
    authHeaderUnsubscribe: `${process.env.VUE_APP_AUTHORIZATION_HEADER_UNSUBSCRIBE}`,
    azureBlob: `${process.env.VUE_APP_AZURE_BLOB}`,
    myMuzeUrl : `${process.env.VUE_APP_MY_MUZE_URL}`,
    campaignHubService: `${process.env.VUE_APP_CAMPAIGN_HUB_SERVICE}`,
    depService: `${process.env.VUE_APP_MTN_DEP_SERVICE}`,
    worldPlayHost: `${process.env.VUE_APP_WORLD_PLAY_HOST}`,
    mtnHeaderEnrichmentUrl: `${process.env.VUE_APP_MTN_HEADER_ENRICHMENT_URL}`,
    tpfHost: 'http://play.rugby-zone.co.za',
    nodeEnv: `Prod`
}

export const developmentConfig = {
    dcbService: `${process.env.VUE_APP_DCB_SERVICE}`,
    triviaService: `${process.env.VUE_APP_TRIVIA_SERVICE}`,
    triviaBasicAuthToken: `${process.env.VUE_APP_TRIVIA_BASIC_AUTH_TOKEN}`,
    triviaLegacyService: `${process.env.VUE_APP_TRIVIA_LEGACY_SERVICE}`,
    utilsService: `${process.env.VUE_APP_UTILS_SERVICE}`,
    upstreamService: `${process.env.VUE_APP_UPSTREAM_SERVICE}`,
    fantasyService: `${process.env.VUE_APP_FANTASY_SERVICE}`,
    gameEngineService: `${process.env.VUE_APP_GAME_ENGINE_SERVICE}`,
    predictorService: `${process.env.VUE_APP_PREDICTOR_SERVICE}`,
    authHeader: `${process.env.VUE_APP_AUTHORIZATION_HEADERS}`,
    authHeaderUnsubscribe: `${process.env.VUE_APP_AUTHORIZATION_HEADER_UNSUBSCRIBE}`,
    azureBlob: `${process.env.VUE_APP_AZURE_BLOB}`,
    myMuzeUrl : `${process.env.VUE_APP_MY_MUZE_URL}`,
    campaignHubService: `${process.env.VUE_APP_CAMPAIGN_HUB_SERVICE}`,
    depService: `${process.env.VUE_APP_MTN_DEP_SERVICE}`,
    worldPlayHost: `${process.env.VUE_APP_WORLD_PLAY_HOST}`,
    mtnHeaderEnrichmentUrl: `${process.env.VUE_APP_MTN_HEADER_ENRICHMENT_URL}`,
    tpfHost: 'https://staging-play.rugby-zone.co.za',
    nodeEnv: `Dev`
}

export const stagingConfig = {
    dcbService: `${process.env.VUE_APP_STAGING_DCB_SERVICE}`,
    triviaService: `${process.env.VUE_APP_TRIVIA_SERVICE}`,
    triviaBasicAuthToken: `${process.env.VUE_APP_TRIVIA_BASIC_AUTH_TOKEN}`,
    triviaLegacyService: `${process.env.VUE_APP_TRIVIA_LEGACY_SERVICE}`,
    utilsService: `${process.env.VUE_APP_UTILS_SERVICE}`,
    fantasyService: `${process.env.VUE_APP_FANTASY_SERVICE}`,
    gameEngineService: `${process.env.VUE_APP_GAME_ENGINE_SERVICE}`,
    upstreamService: `${process.env.VUE_APP_UPSTREAM_SERVICE}`,
    predictorService: `${process.env.VUE_APP_PREDICTOR_SERVICE}`,
    authHeader: `${process.env.VUE_APP_AUTHORIZATION_HEADERS}`,
    authHeaderUnsubscribe: `${process.env.VUE_APP_AUTHORIZATION_HEADER_UNSUBSCRIBE}`,
    azureBlob: `${process.env.VUE_APP_AZURE_BLOB}`,
    myMuzeUrl : `${process.env.VUE_APP_MY_MUZE_URL}`,
    campaignHubService: `${process.env.VUE_APP_CAMPAIGN_HUB_SERVICE}`,
    depService: `${process.env.VUE_APP_MTN_DEP_SERVICE}`,
    worldPlayHost: `${process.env.VUE_APP_WORLD_PLAY_HOST}`,
    mtnHeaderEnrichmentUrl: `${process.env.VUE_APP_MTN_HEADER_ENRICHMENT_URL}`,
    tpfHost: 'https://staging-play.rugby-zone.co.za',
    nodeEnv: `Prod`
}

const environment = getEnvironment()

export const environmentConfig = getEnvObject();

function getEnvironment() {
    let base_url = window.location.origin;
    if (base_url.includes('staging')) return 'staging'
    if (base_url.includes('localhost')) return 'development'
    else return 'production'
}

function getEnvObject() {
    if (environment === 'staging') return stagingConfig
    if (environment === 'development') return developmentConfig
    if (environment === 'production') return productionConfig
}
